import * as errorTypes from '../../constants/errorStatuses';

function toErrorKey(status, isNL) {
  // this table defines static error messages (see spec) that need to work offline
  switch (status) {
    // payment cancel, used for all payment methods
    case errorTypes.PAYMENT_CANCEL:
      return isNL
        ? 'De betaling is afgebroken. Wij verzoeken u het nogmaals te proberen.'
        : 'Die Durchführung der Zahlung wurde leider abgebrochen. Bitte versuchen Sie es erneut.';
    // Payment failed, used for all payment methods
    case errorTypes.PAYMENT_EXPIRED:
    case errorTypes.PAYMENT_PENDING:
    case errorTypes.PAYMENT_UNAUTHORIZED:
    case errorTypes.PAYMENT_FAIL:
      return isNL
        ? 'De betaling is vanwege een technische fout niet gelukt. Wij verzoeken u het nogmaals te proberen of contact met ons op te nemen.'
        : 'Aufgrund eines technischen Fehlers wurde die Zahlung leider nicht erfolgreich durchgeführt. Bitte versuchen Sie es erneut oder melden Sie sich bei uns.';
    // Timeout des Logins (sowohl manuelles Login als auch per Depplink mit Token)
    // ODER Fehlende Zugriffsrechte (primär wenn Seiten z.B. per Back-Button nach Logout aufgerufen werden)
    case errorTypes.FORBIDDEN:
      return isNL
        ? 'Om uw gegevens te beschermen, loggen wij u automatisch uit wanneer u onze website niet gebruikt. Wij verzoeken u opnieuw in te loggen.'
        : 'Um Ihre Daten zu schützen, loggen wir Sie automatisch aus, wenn Sie unsere Seite nicht nutzen. Bitte loggen Sie sich daher wieder ein.';
    // Timeout of the API (slow conneciton)
    case errorTypes.TIMEOUT:
    case errorTypes.ABORT_ERROR:
      return isNL
        ? 'Er zijn helaas verbindingsproblemen opgetreden. Wij verzoeken u een betere verbinding te zoeken en het opnieuw te proberen.'
        : 'Leider gibt es Verbindungsprobleme. Bitte suchen sie einen besseren Netzempfang und versuchen es erneut.';
    // Fehler der API
    case errorTypes.SERVER_ERROR:
      return isNL
        ? 'Het klantenportaal is op dit moment niet beschikbaar. Wij vragen je om het op een later tijdstip nog eens te proberen.'
        : 'Das Kundencenter steht zur Zeit nicht zur Verfügung. Versuchen Sie es bitte zu einem späteren Zeitpunkt noch einmal.';
    // Error in the UI (React or in sagas)
    case errorTypes.EXCEPTION:
      return isNL
        ? 'De pagina werd niet goed geladen. Wij vragen je de pagina opnieuw te laden of de terug knop te gebruiken.'
        : 'Die Seite wurde leider nicht richtig geladen. Bitte laden Sie die Seite neu oder benutzen Sie den Zurück-Button.';
    // Page cannot be loaded (most likely stale bookmark, possibly error in deployment)
    // or API 404 error
    case errorTypes.NOT_FOUND:
      return isNL
        ? 'De pagina kan niet worden geladen. Wij vragen je de pagina opnieuw te laden of de terug knop te gebruiken.'
        : 'Die Seite wurde leider nicht richtig geladen. Bitte laden Sie die Seite neu oder benutzen Sie den Zurück-Button.';
    // andere Fehler
    default:
      return isNL
        ? 'De pagina werd niet goed geladen. Wij vragen je de pagina opnieuw te laden of de terug knop te gebruiken.'
        : 'Die Seite wurde leider nicht richtig geladen. Bitte laden Sie die Seite neu oder benutzen Sie den Zurück-Button.';
  }
}

export default toErrorKey;
